import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHead, Btn, Card, Field, Select, Toggle, Label } from "@/admin/ui";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";

const DropLaunch = () => {
  const [collections, setCollections] = useState([]);
  const [target, setTarget] = useState("");
  const [dropName, setDropName] = useState("");
  const [category, setCategory] = useState("Sets");
  const [department, setDepartment] = useState("women");
  const [names, setNames] = useState("");
  const [fill, setFill] = useState(true);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => { api.get("/admin/collections").then((r) => setCollections(r.data)).catch(() => {}); }, []);

  const launch = async () => {
    const list = names.split("\n").map((x) => x.trim()).filter(Boolean);
    if (!list.length) { toast("Add at least one piece name."); return; }
    if (!target && !dropName.trim()) { toast("Name the drop or pick a collection."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/admin/drops/launch", {
        names: list, category, department, fill,
        collection_slug: target || undefined,
        collection_name: target ? undefined : dropName.trim(),
      });
      toast.success(`Launched ${data.created.length} piece(s)`);
      nav("/admin/products");
    } catch (e) {
      toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Launch failed");
    }
    setBusy(false);
  };

  return (
    <div className="max-w-2xl">
      <PageHead title="Launch a Drop" sub="Spin up a whole drop in one go — create the pieces, draft their copy, and set their order." />
      <Card>
        <Select label="Add to" value={target} onChange={setTarget}
          options={[{ value: "", label: "Create a new drop…" }, ...collections.map((c) => ({ value: c.slug, label: c.name }))]} />
        {!target && <Field label="New drop name" value={dropName} onChange={setDropName} placeholder="e.g. Drop 002 — Harmattan" />}
        <div className="grid md:grid-cols-2 gap-x-5">
          <Field label="Category" value={category} onChange={setCategory} placeholder="Sets, Outerwear…" />
          <Select label="Department" value={department} onChange={setDepartment} options={[{ value: "women", label: "Women" }, { value: "men", label: "Men" }]} />
        </div>
        <Label>Piece names (one per line — order sets their sequence)</Label>
        <textarea data-testid="drop-names" value={names} onChange={(e) => setNames(e.target.value)} rows={6}
          placeholder={"The Origin Set\nThe Cowrie Wrap\nThe Harmattan Coat"}
          className="w-full bg-ivory border border-espresso/20 px-3 py-2.5 text-sm outline-none focus:border-espresso mb-4" />
        <Toggle label={`Draft copy with AI ${fill ? "ON" : "OFF"}`} value={fill} onChange={setFill} testid="drop-fill" />
        <p className="text-xs text-espresso/50 mt-1 mb-5">Each piece gets a drafted description, care notes and SEO — unknowns marked [to confirm]. Pieces are created as drafts for your review.</p>
        <Btn onClick={launch} disabled={busy} testid="drop-launch">
          {busy ? <Loader2 size={13} className="animate-spin inline" /> : <Sparkles size={13} className="inline" />} Launch drop
        </Btn>
      </Card>
    </div>
  );
};

export default DropLaunch;
